import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Filled = styled.span`
  color: #00c087;
`

const Partial = styled.span`
  color: #f0b90b;
`

const Cancel = styled.span`
  color: #48515d;
`

const Failed = styled.span`
  color: ${({ theme }) => theme.down};
`

class Status extends PureComponent {
  static propTypes = {
    text: PropTypes.string,
  }

  static defaultProps = {
    text: '',
  }

  render() {
    const { text } = this.props
    return (
      <div>
        {text === 'Partial' && <Partial>{text}</Partial>}
        {text === 'Expired' && <Cancel>{text}</Cancel>}
        {text === 'Canceled' && <Cancel>{text}</Cancel>}
        {text === 'Filled' && <Filled>{text}</Filled>}
        {text === 'Failed' && <Failed>{text}</Failed>}
      </div>
    )
  }
}

export default Status
